export enum RatesheetLevels {
  TeamTask,
  ChannelSuggestion,
}
